<template>
  <div>
    <b-row v-if="stateError.show">
      <b-col>
        <b-alert show variant="danger" dismissible @dismissed="handleDismissed">
          {{ stateError.msg }}
        </b-alert>
      </b-col>
    </b-row>
    <auto-fill-button @clicked="fillStepTwoForm" />
    <h2 class="text-mobile-sub-title sub-title ml-0 mb-2">{{ FormMSG(256, 'Personal data') }}</h2>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(257, 'First name')" />
      </template>
      <b-form-input
        v-model="dataToSend.firstName"
        :placeholder="FormMSG(1987, 'Enter first name')"
        :class="{
          'is-invalid': $v.dataToSend.firstName.$error
        }"
        @keyup="handleInputChanged('dataToSend.firstName')"
      />
      <div v-if="$v.dataToSend.firstName.$error" class="invalid-feedback">
        {{ FormMSG(1988, 'Please enter first name') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(258, 'Last name')" />
      </template>
      <b-form-input
        v-model="dataToSend.name"
        :placeholder="FormMSG(1010, 'Enter last name')"
        :class="{
          'is-invalid': $v.dataToSend.name.$error
        }"
        @keyup="handleInputChanged('dataToSend.name')"
      />
      <div v-if="$v.dataToSend.name.$error" class="invalid-feedback">
        {{ FormMSG(3011, 'Please enter last name') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(259, 'Email address')" />
      </template>
      <b-form-input :value="dataToSend.email" disabled />
    </b-form-group>
    <b-form-group>
      <!-- <pre>{{ phone }}</pre> -->
      <!-- <pre>{{ dataToSend }}</pre> -->
      <template #label>
        <custom-label-mandatory :label="FormMSG(987454, 'Phone number')" />
      </template>
      <div class="d-flex">
        <div>
          <b-input-group-prepend style="height: 100%">
            <b-input-group-text style="border-radius: 0.25rem 0 0 0.25rem">
              <component :is="getLucideIcon('Phone')" color="#4d4e4f" :size="16" />
            </b-input-group-text>
          </b-input-group-prepend>
        </div>
        <div class="w-100">
          <div v-if="phoneInited" class="w-100">
            <VuePhoneNumberInput
              id="phone-number"
              v-model="phone"
              error-color="#EA4E2C"
              valid-color="#00AF75"
              size="sm"
              :translations="optionsTranslation"
              :disabled="phoneValidated"
              fetch-country
              :class="{
                'is-invalid': $v.phone.$error && getStateValidationField('phone') !== null
              }"
              @update="handleUpdatePhoneNumber"
            />
          </div>
          <div v-else>
            <VuePhoneNumberInput
              id="phone-number"
              v-model="phone"
              error-color="#EA4E2C"
              valid-color="#00AF75"
              size="sm"
              :translations="optionsTranslation"
              :disabled="phoneValidated"
              :default-country-code="'BE'"
              :class="{
                'is-invalid': $v.phone.$error && getStateValidationField('phone') !== null
              }"
              @update="handleUpdatePhoneNumber"
            />
          </div>
        </div>
      </div>
      <div v-if="$v.phone.$error && getStateValidationField('phone') !== null" class="invalid-feedback">
        {{ FormMSG(8926565, 'Phone number is required and please, enter your validation code') }}
      </div>
    </b-form-group>
    <b-row v-if="!phoneValidated" class="mb-3">
      <b-col v-if="showVerificationPhone" :cols="12" :sm="12" :lg="8" :xl="8">
        <b-form-group>
          <template #label>
            <custom-label-mandatory :label="FormMSG(597, 'Phone verification code')" />
          </template>
          <b-form-input
            ref="code-validation"
            v-model="phoneCodeValidation"
            :class="{
              'is-invalid': $v.phoneCodeValidation.$error
            }"
            :disabled="validateCodePhone"
            @input="handleInputPhoneCodeValidation"
          />
        </b-form-group>
      </b-col>
      <b-col
        :cols="12"
        :sm="12"
        :lg="!showVerificationPhone ? 12 : 4"
        :xl="!showVerificationPhone ? 12 : 4"
        :class="{ 'd-flex align-items-end pb-3': showVerificationPhone }"
      >
        <b-button
          :variant="variantPhoneBtn()"
          block
          :disabled="dataToSend.phone !== '' || disableVerifyPhone || loadingFor.verifyPhone"
          class="d-flex justify-content-center align-items-center"
          @click="verifyPhone"
        >
          <b-spinner v-if="loadingFor.verifyPhone" small />
          <div v-if="!loadingFor.verifyPhone" :class="`${loadingFor.verifyPhone ? 'pl-2' : ''}`" style="margin-top: 1px">
            {{ labelPhoneAction }}
          </div>
        </b-button>
      </b-col>
    </b-row>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(261, 'Nationality')" />
      </template>
      <b-form-input
        v-model="dataToSend.nationality"
        :placeholder="FormMSG(1012, 'Enter nationality')"
        :class="{
          'is-invalid': $v.dataToSend.nationality.$error
        }"
        @keyup="handleInputChanged('dataToSend.nationality')"
      />
      <div v-if="$v.dataToSend.nationality.$error" class="invalid-feedback">
        {{ FormMSG(2013, 'Please enter nationality') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(262, 'Language')" not-required />
      </template>
      <b-form-select v-model="dataToSend.language" :options="optionsForLanguages" />
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(263, 'Gender')" />
      </template>
      <b-form-select
        v-model="dataToSend.gender"
        :options="menuGenders"
        :class="{
          'is-invalid': $v.dataToSend.gender.$error
        }"
        @change="handleInputChanged('dataToSend.gender')"
      />
      <div v-if="$v.dataToSend.gender.$error" class="invalid-feedback">
        {{ FormMSG(1674, 'Please select a gender') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label><custom-label-mandatory :label="FormMSG(265, 'Birthdate')" /> </template>
      <v-date-picker :value="dataToSend.birthDate" :masks="{ input: 'DD/MM/YYYY' }" @input="handleInputBirthDate">
        <template #default="{ inputValue, togglePopover }">
          <b-input-group>
            <b-form-input
              v-mask="'##/##/####'"
              :value="mapInputDate(dataToSend.birthDate, inputValue)"
              class="bg-white"
              :placeholder="FormMSG(896, 'DD/MM/YYYY')"
              :class="{
                'is-invalid': $v.dataToSend.birthDate.$error
              }"
              readonly
              @click="togglePopover"
            />
            <b-input-group-append>
              <b-input-group-text class="cursor-pointer" @click="togglePopover">
                <component :is="getLucideIcon('Calendar')" color="#06263E" :size="16" />
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </template>
      </v-date-picker>
      <div v-if="$v.dataToSend.birthDate.$error && getStateValidationField('dataToSend.birthDate')" class="invalid-feedback">
        {{ FormMSG(1563, 'Please enter birthdate') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(266, 'Place of birth(City and Country)')" />
      </template>
      <b-form-input
        v-model="dataToSend.placeOfBirth"
        :class="{
          'is-invalid': $v.dataToSend.placeOfBirth.$error
        }"
        :placeholder="FormMSG(1698, 'Enter place of birth')"
        @keyup="handleInputChanged('dataToSend.placeOfBirth')"
      />
      <div v-if="$v.dataToSend.placeOfBirth.$error" class="invalid-feedback">
        {{ FormMSG(2699, 'Please enter place of birth') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(1266, 'Country of birth')" />
      </template>
      <b-form-input
        v-model="dataToSend.birthCountry"
        :class="{
          'is-invalid': $v.dataToSend.birthCountry.$error
        }"
        :placeholder="FormMSG(1698454, 'Enter Country of birth')"
        @keyup="handleInputChanged('dataToSend.birthCountry')"
      />
      <div v-if="$v.dataToSend.birthCountry.$error" class="invalid-feedback">
        {{ FormMSG(2851, 'Please enter country of birth') }}
      </div>
    </b-form-group>
    <h2 class="text-mobile-sub-title sub-title ml-0 mb-2">{{ FormMSG(270, 'Identification') }}</h2>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(271, 'National registration number')" />
      </template>
      <InputMask
        v-model="dataToSend.nationalRegistryNumber"
        class="form-control"
        mask="99.99.99-999-99"
        :placeholder="FormMSG(1700, 'Enter national registration number')"
        :class="{
          'is-invalid': $v.dataToSend.nationalRegistryNumber.$error
        }"
        @keyup="handleInputMaskChanged"
      />
      <div v-if="$v.dataToSend.nationalRegistryNumber.$error" class="invalid-feedback">
        {{ FormMSG(1701, 'Please enter national registration number') }}
      </div>
      <!--  && getStateValidationField('dataToSend.nationalRegistryNumber') -->
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(2720, 'Company number')" not-required />
      </template>
      <b-form-input v-model="dataToSend.companyNumber" :placeholder="FormMSG(1703, 'Enter company number')" />
    </b-form-group>

    <h2 class="text-mobile-sub-title sub-title ml-0 mb-2">{{ FormMSG(2730, 'Financial information') }}</h2>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(275, 'Tax withholding')" />
      </template>
      <b-input-group>
        <b-form-input
          v-model="dataToSend.taxesPercentage"
          :placeholder="FormMSG(1705, 'Enter tax with holding')"
          type="number"
          step="1"
          min="0"
          max="100"
          :class="{
            'is-invalid': $v.dataToSend.taxesPercentage.$error
          }"
          @keyup="handleNumberOnly"
        />
        <b-input-group-append>
          <b-input-group-text class="cursor-pointer">
            <component :is="getLucideIcon('Percent')" color="#06263E" :size="16" />
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>
      <div v-if="$v.dataToSend.taxesPercentage.$error" class="invalid-feedback">
        {{ FormMSG(1706, 'Please enter tax with holding') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(279, 'Iban')" />
      </template>
      <b-form-input
        v-model="dataToSend.iban"
        :placeholder="FormMSG(1707, 'Enter iban')"
        :class="{
          'is-invalid': $v.dataToSend.iban.$error
        }"
      />
      <div v-if="$v.dataToSend.iban.$error" class="invalid-feedback">
        {{ FormMSG(1708, 'Please enter iban') }}
      </div>
    </b-form-group>
    <b-form-group :label="FormMSG(280, 'Bic (if not in Belgium)')">
      <b-form-input v-model="dataToSend.bic" :placeholder="FormMSG(1709, 'Enter Bic')" />
    </b-form-group>
    <b-row>
      <b-col sm="12" :md="imageInDb && imageInDb !== '' ? 10 : 12" :lg="imageInDb && imageInDb !== '' ? 10 : 12" :xl="imageInDb && imageInDb !== '' ? 10 : 12">
        <b-form-group :label="FormMSG(281, 'Bank detail document (in not in Belgium)')">
          <b-form-file
            ref="accomodation-file"
            class="mb-2"
            :accept="'.pdf,.xlsx,.xls,.doc,.docx'"
            :placeholder="FormMSG(63, 'Choose a file or drop it here ...')"
            :browse-text="FormMSG(64, 'Browse')"
            :drop-placeholder="FormMSG(65, 'Drop file here ...')"
            @change="handleChangeFileToUploaded"
          />
        </b-form-group>
      </b-col>
      <b-col v-if="imageInDb && imageInDb !== ''" sm="12" md="2" lg="2" xl="2">
        <div class="w-100 text-center" :style="$screen.width <= 576 ? '' : 'padding-top: 22px'">
          <b-button-group tag="div">
            <b-button variant="outline-primary" @click="handleClickViewImage">
              <component :is="getLucideIcon('Eye')" :size="16" />
            </b-button>
            <b-button variant="danger" @click="handleClickRemoveImage">
              <component :is="getLucideIcon('Trash2')" :size="16" />
            </b-button>
          </b-button-group>
        </div>
      </b-col>
    </b-row>
    <h2 class="text-mobile-sub-title sub-title ml-0 mb-2">{{ FormMSG(1517, 'Address') }}</h2>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(285, 'Country')" />
      </template>
      <v-select
        v-model="dataToSend.countryKey"
        :options="countries"
        label="text"
        :clearable="false"
        :reduce="(option) => option.value"
        :class="{ 'is-invalid': $v.dataToSend.countryKey.$error }"
        @input="getCountry"
      />
      <div v-if="$v.dataToSend.countryKey.$error" class="invalid-feedback">
        {{ FormMSG(4543242, 'Please select country') }}
      </div>
    </b-form-group>
    <google-auto-complete
      ref="google-search-address"
      :label="FormMSG(286, 'Internet search')"
      :country="dataToSend.internalSearch"
      @placechanged="(item) => handleAutoComplete(item)"
    />
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(287, 'Street')" />
      </template>
      <b-form-input v-model="dataToSend.street" :class="{ 'is-invalid': $v.dataToSend.street.$error }" :placeholder="FormMSG(1589, 'Enter street')" />
      <div v-if="$v.dataToSend.street.$error" class="invalid-feedback">
        {{ FormMSG(45254, 'Please enter street') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(288, 'Number')" />
      </template>
      <b-form-input v-model="dataToSend.number" :class="{ 'is-invalid': $v.dataToSend.number.$error }" :placeholder="FormMSG(4781, 'Enter number')" />
      <div v-if="$v.dataToSend.number.$error" class="invalid-feedback">
        {{ FormMSG(4782, 'Please enter number') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(289, 'Postal code')" />
      </template>
      <b-form-input v-model="dataToSend.zip" :class="{ 'is-invalid': $v.dataToSend.zip.$error }" :placeholder="FormMSG(1478, 'Enter postal code')" />
      <div v-if="$v.dataToSend.zip.$error" class="invalid-feedback">
        {{ FormMSG(1456, 'Please enter postal code') }}
      </div>
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(291, 'City')" />
      </template>
      <b-form-input v-model="dataToSend.city" :class="{ 'is-invalid': $v.dataToSend.city.$error }" :placeholder="FormMSG(2547, 'Enter city')" />
      <div v-if="$v.dataToSend.city.$error" class="invalid-feedback">
        {{ FormMSG(2548, 'Please enter city') }}
      </div>
    </b-form-group>
    <b-form-group>
      <label for="state">{{ FormMSG(2002, 'Social Security Number') }} </label>
      <b-form-input
        v-model="dataToSend.socSecNumber"
        :placeholder="FormMSG(2003, 'Enter your Social Security Number')"
        maxlength="15"
        @input="handleSocSecNumberChange"
        @keydown.enter.prevent
      />
      <div v-if="isSocSecNumberWarning" class="warning-feedback">
        {{ FormMSG(8979997, 'The social security number seems not valid') }}
      </div>
    </b-form-group>
    <h2 class="text-mobile-sub-title sub-title ml-0 mb-2">{{ FormMSG(293, 'Family') }}</h2>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(294, 'Civil status')" />
      </template>
      <b-form-select
        v-model="dataToSend.civilStatus"
        :options="optionsForCivilStatus"
        :class="{
          'is-invalid': $v.dataToSend.civilStatus.$error
        }"
        @change="handleChangeCivilStatus"
      />
      <div v-if="$v.dataToSend.civilStatus.$error" class="invalid-feedback">
        {{ FormMSG(46532, 'Please, choose a civil status') }}
      </div>
    </b-form-group>
    <b-form-group v-if="showSpouseInfo">
      <template #label>
        <custom-label-mandatory :label="FormMSG(295, 'Spouse first name')" not-required />
      </template>
      <b-form-input v-model="dataToSend.spouseFirstName" :placeholder="FormMSG(1584, 'Enter spouse first name')" />
    </b-form-group>
    <b-form-group v-if="showSpouseInfo">
      <template #label>
        <custom-label-mandatory :label="FormMSG(296, 'Spouse last name')" not-required />
      </template>
      <b-form-input v-model="dataToSend.spouseName" :placeholder="FormMSG(1586, 'Enter spouse last name')" />
    </b-form-group>
    <b-form-group v-if="showSpouseInfo">
      <template #label>
        <custom-label-mandatory :label="FormMSG(297, 'Wedding date')" not-required />
      </template>
      <v-date-picker :value="dataToSend.mariedOn" :masks="{ input: 'DD/MM/YYYY' }" @input="handleInputWeddingDate">
        <template #default="{ inputValue, togglePopover }">
          <b-input-group>
            <b-form-input :value="mapInputDate(dataToSend.mariedOn, inputValue)" readonly class="bg-white" @click="togglePopover" />
            <b-input-group-append>
              <b-input-group-text class="cursor-pointer" @click="togglePopover">
                <component :is="getLucideIcon('Calendar')" color="#06263E" :size="16" />
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </template>
      </v-date-picker>
    </b-form-group>
    <b-form-group v-if="showSpouseInfo" :label="FormMSG(298, 'Spouse profession')">
      <b-form-input v-model="dataToSend.spouseProfession" :placeholder="FormMSG(847, 'Enter spouse profession')" />
    </b-form-group>
    <b-form-group v-if="showSpouseInfo">
      <template #label>
        <custom-label-mandatory :label="FormMSG(300, 'Spouse birth date')" not-required />
      </template>
      <v-date-picker :value="dataToSend.spouseBirthDate" :masks="{ input: 'DD/MM/YYYY' }" @input="handleInputSpouseBirthDate">
        <template #default="{ inputValue, togglePopover }">
          <b-input-group>
            <b-form-input :value="mapInputDate(dataToSend.spouseBirthDate, inputValue)" readonly class="bg-white" @click="togglePopover" />
            <b-input-group-append>
              <b-input-group-text class="cursor-pointer" @click="togglePopover">
                <component :is="getLucideIcon('Calendar')" color="#06263E" :size="16" />
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </template>
      </v-date-picker>
    </b-form-group>
    <b-form-group v-if="showSpouseInfo" :label="FormMSG(299, 'Spouse has salary')">
      <b-form-checkbox v-model="dataToSend.spouseHasSalary" switch size="lg" />
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(301, 'Number of dependent child')" not-required />
      </template>
      <b-form-input v-model="dataToSend.numberOfDependentChild" type="number" step="1" min="0" placeholder="0" />
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(1302, 'Number of disabled child')" not-required />
      </template>
      <b-form-input v-model="dataToSend.numberOfDisabledChild" type="number" step="1" min="0" placeholder="0" />
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(303, 'Number of dependent person')" not-required />
      </template>
      <b-form-input v-model="dataToSend.numberOfDependentPerson" type="number" step="1" min="0" placeholder="0" />
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(304, 'Number of disabled person ')" not-required />
      </template>
      <b-form-input v-model="dataToSend.numberOfDisabledPerson" type="number" step="1" min="0" placeholder="0" />
    </b-form-group>
    <h2 class="text-mobile-sub-title sub-title ml-0 mb-2">{{ FormMSG(305, 'Emergency contact') }}</h2>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(306, 'Person to contact name')" not-required />
      </template>
      <b-form-input v-model="dataToSend.personToContact" :placeholder="FormMSG(1689, 'Enter person to contact name')" />
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(307, 'Person to contact phone')" not-required />
      </template>
      <b-form-input v-model="dataToSend.personToContactPhone" :placeholder="FormMSG(1690, 'Enter person to contact phone')" />
    </b-form-group>
    <h2 class="text-mobile-sub-title sub-title ml-0 mb-2">{{ FormMSG(308, 'Study') }}</h2>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(1307, 'Are you currently a student ?')" not-required />
      </template>
      <b-form-checkbox v-model="dataToSend.studyCurrently" switch size="lg" @change="handleChangeStudyCurrently" />
    </b-form-group>
    <b-form-group>
      <template #label>
        <custom-label-mandatory :label="FormMSG(311, 'Study level')" not-required />
      </template>
      <b-form-select v-model="dataToSend.studyLevel" :options="studyLevelOptions" />
    </b-form-group>
    <b-modal
      v-model="showModalInfoCode"
      header-class="header-class-modal-doc-package"
      :title="FormMSG(1282, 'Validation code')"
      class="modal-success"
      ok-variant="success"
      ok-only
      @ok="closeValidationCode()"
    >
      {{ messageModalInfoCode }}
    </b-modal>
  </div>
</template>

<script>
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import CustomLabelMandatory from './CustomLabelMandatory.vue';
import { Phone } from 'lucide-vue';
import _ from 'lodash';
import { NANP_COUNTRY_CODES } from '@/shared/constants';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { phoneValidationCode, checkLicensePhoneValidationCode } from '@/cruds/registration.crud';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import GoogleAutoComplete from '@/components/GoogleAutoComplete';
import { greaterThanZero, noTilde, nationalRegistryNumberValid } from '~utils';
import { STUDY_LEVEL_MENU } from '../../../shared/constants';
import InputMask from 'primevue/inputmask';
import AutoFillButton from './experimentals/AutoFillButton.vue';

export default {
  name: 'StepTwoForm',
  components: {
    Phone,
    CustomLabelMandatory,
    VuePhoneNumberInput,
    'v-date-picker': DatePicker,
    GoogleAutoComplete,
    InputMask,
    AutoFillButton
  },
  mixins: [languageMessages, globalMixin, validationMixin],
  props: {
    isEnvDev: {
      type: Boolean,
      required: true
    },
    userData: { type: Object, default: () => {}, required: false },
    propMaskInTouch: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      imageInDb: '',
      phone: null,
      phoneValidated: false,
      validateCodePhone: false,
      phoneE164: '',
      disableVerifyPhone: true,
      isNANPCountry: false,
      phoneCodeValidation: null,
      phoneInited: false,
      dataToCheck: {
        phone: '',
        phoneCodeValidation: 0,
        licenseId: ''
      },
      loadingFor: {
        verifyPhone: false
      },
      stateError: {
        show: false,
        msg: '',
        phoneCodeValidation: null
      },
      showModalInfoCode: false,
      messageModalInfoCode: '',
      isSocSecNumberWarning: false,
      dataToSend: {
        phone: '',
        firstName: null,
        name: null,
        email: '',
        nationality: null,
        language: 0,
        gender: null,
        birthDate: null,
        placeOfBirth: null,
        birthCountry: null,
        nationalRegistryNumber: null,
        companyNumber: null,
        taxesPercentage: null,
        iban: null,
        bic: '',
        // ADDRESS
        country: '',
        internalSearch: null,
        street: null,
        number: null,
        zip: null,
        city: null,
        countryKey: 16965,
        countryCode: '',
        civilStatus: 0,
        spouseFirstName: null,
        spouseName: null,
        mariedOn: null,
        spouseProfession: '',
        spouseHasSalary: false,
        numberOfDependentChild: 0,
        numberOfDisabledChild: 0,
        numberOfDependentPerson: 0,
        numberOfDisabledPerson: 0,
        personToContact: null,
        personToContactPhone: null,
        studyCurrently: false,
        studyLevel: 0,
        bankDetailXid: null,
        spouseBirthDate: null,
        socSecNumber: ''
      },
      inputMaskInTouch: false
    };
  },
  computed: {
    studyLevelOptions() {
      return [{ value: 0, text: this.FormMSG(1547, 'Please select ...') }, ...this.FormMenu(STUDY_LEVEL_MENU)];
    },
    showSpouseInfo() {
      return [3, 6, 7].includes(this.dataToSend.civilStatus);
    },
    optionsForCivilStatus() {
      return this.FormMenu(1001);
    },
    countries() {
      let countries = this.FormMenu(8);

      countries.sort((a, b) => {
        if (noTilde(a.text).toLowerCase() < noTilde(b.text).toLowerCase()) {
          return -1;
        }
        if (noTilde(a.text).toLowerCase() > noTilde(b.text).toLowerCase()) {
          return 1;
        }

        return 0;
      });

      return countries;
    },
    menuGenders() {
      const res = this.FormMenu(1002);
      return [{ value: null, text: this.FormMSG(165, 'Please select an option') }, ...res];
    },
    optionsForLanguages() {
      return this.FormMenu(1115);
    },
    showVerificationPhone() {
      if (this.dataToCheck.phoneCodeValidation !== 0) {
        return true;
      }
      return false;
    },
    optionsTranslation() {
      return {
        countrySelectorLabel: this.FormMSG(54, 'Country code'),
        countrySelectorError: this.FormMSG(55, 'Choose a country'),
        phoneNumberLabel: this.FormMSG(56, 'Phone number'),
        example: 'Ex : '
      };
    },
    labelPhoneAction() {
      if (this.isNANPCountry) {
        return this.FormMSG(159, 'Validated');
      }
      if (this.dataToCheck.phoneCodeValidation !== 0 && !this.loadingFor.verifyPhone) {
        return this.FormMSG(48, 'Resend code');
      }
      if (!this.loadingFor.verifyPhone && this.dataToCheck.phoneCodeValidation === 0) {
        return this.FormMSG(656565, 'Please, verify your phone number');
      }
      if (this.loadingFor.verifyPhone) {
        return this.FormMSG(50, 'Check phone');
      }

      return '';
    }
  },
  watch: {
    userData: {
      handler(newVal) {
        if (newVal.phone !== '') {
          this.phone = newVal.phone;
          this.phoneE164 = newVal.phone;
          this.phoneInited = true;
          this.phoneCodeValidation = '0000';
        }

        if (newVal.bankDetailXid && newVal.bankDetailXid !== '') {
          this.imageInDb = newVal.bankDetailXid;
        }

        this.dataToSend = _.cloneDeep(newVal);
        this.dataToSend.bankDetailXid = null;
      },
      immediate: true,
      deep: true
    },
    dataToSend: {
      handler(newVal) {
        this.$emit('step-two-form:change', { data: newVal });
      },
      deep: true,
      immediate: true
    },
    propMaskInTouch: {
      handler(value) {
        this.inputMaskInTouch = value;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    generateFormdata() {
      const randomFiller = this.generateRandomText(6).toLowerCase();
      const randomNumber = this.generateRandomNumber(6);
      const phoneTest = '+261349388953'; // Lanja: phone-number
      const phoneTestToContact = '+32485111222'; // Random: phone-number
      return {
        phone: phoneTest,
        firstName: `Jean-${randomFiller}`,
        name: 'Dupont',
        email: this.dataToSend.email ? this.dataToSend.email : `jeandupont.${randomFiller}+${randomNumber}@example.be`,
        nationality: 'Belgian',
        language: 0, // english
        gender: 0, // Male
        birthDate: '1985-06-15T00:00:00Z',
        placeOfBirth: 'Bruxelles',
        birthCountry: 'Belgium',
        nationalRegistryNumber: '85.06.15-123-45', // fake but valid pattern
        companyNumber: '0733123456', // BCE/KBO 10-digit number
        taxesPercentage: 21, // standard VAT %
        iban: 'BE71096123456769', // Belgian IBAN example
        bic: '', // User is in belgium
        // ADDRESS
        country: 'Belgium',
        internalSearch: null,
        street: 'Avenue Louise',
        number: '231',
        zip: '1050',
        city: 'Ixelles',
        countryKey: 16965, // belgium
        countryCode: 'BE',
        civilStatus: 3, // married
        spouseFirstName: `Marie-${randomFiller}`,
        spouseName: 'Dubois',
        mariedOn: '2015-09-12T00:00:00Z',
        spouseProfession: 'Teacher',
        spouseHasSalary: true,
        numberOfDependentChild: 2,
        numberOfDisabledChild: 0,
        numberOfDependentPerson: 0,
        numberOfDisabledPerson: 0,
        personToContact: 'Paul Dupont',
        personToContactPhone: phoneTestToContact,
        studyCurrently: true,
        studyLevel: 11, // Other
        bankDetailXid: null,
        spouseBirthDate: '1987-04-22T00:00:00Z',
        socSecNumber: '850615-123.45' // random formatted Belgian NR
      };
    },
    fillStepTwoForm() {
      /** /!\ WARNING: This content is for developer mode only, be careful to verify it is not used on production */
      const generated = this.generateFormdata();
      this.phone = generated.phone;
      this.phoneE164 = generated.phone;
      this.phoneCodeValidation = this.generateRandomNumber(4);
      this.phoneInited = true;
      this.phoneValidated = true;
      this.dataToSend = { ...generated };
      this.inputMaskInTouch = true;
      this.$v.$touch();
    },
    variantPhoneBtn() {
      if (this.disableVerifyPhone === true && this.loadingFor.verifyPhone === false && this.dataToCheck.phoneCodeValidation === 0) {
        return 'outline-primary';
      } else if (this.disableVerifyPhone === false) {
        return 'outline-danger';
      }

      return 'primary';
    },
    mapInputDate(dateDefault, value) {
      if (!_.isNil(dateDefault)) {
        return value;
      }

      return '';
    },
    handleInputWeddingDate(payload) {
      this.dataToSend.mariedOn = payload;
    },
    handleSocSecNumberChange(value) {
      this.dataToSend.socSecNumber = value;
      this.isSocSecNumberWarning = _.isNil(value);
    },
    handleInputSpouseBirthDate(payload) {
      this.dataToSend.spouseBirthDate = payload;
    },
    handleChangeCivilStatus(payload) {
      if (![3, 6, 7].includes(payload)) {
        this.dataToSend.spouseFirstName = null;
        this.dataToSend.spouseName = null;
        this.dataToSend.mariedOn = null;
        this.dataToSend.spouseProfession = '';
        this.dataToSend.spouseHasSalary = false;
      } else {
        this.dataToSend.mariedOn = this.dataToSend.mariedOn === null || this.dataToSend.mariedOn === '0001-01-01T00:00:00Z' ? null : this.dataToSend.mariedOn;
      }
    },
    handleClickViewImage() {
      const url = `${process.env.VUE_APP_GQL}/images/${this.imageInDb}`;
      window.open(url, '_blank');
    },
    async handleClickRemoveImage(showConfirm = true) {
      if (showConfirm) {
        const action = async () => {
          alert(this.imageInDb);
          await this.$axios.$get(`/removeimage/${this.imageInDb}`);
          this.imageInDb = '';
        };
        this.confirmModal(action, this.FormMSG(457, 'Are you sure ?'));
      } else {
        await this.$axios.$get(`/removeimage/${this.imageInDb}`);
        this.imageInDb = '';
      }
    },
    async handleChangeFileToUploaded(e) {
      let eventFile = null;
      if (e.type === 'drop') {
        eventFile = e.dataTransfer.files[0];
      } else {
        eventFile = e.target.files[0];
      }

      this.dataToSend.bankDetailXid = eventFile;

      if (this.imageInDb !== '') {
        await this.handleClickRemoveImage(false);
      }

      const fileReader = new FileReader();
      fileReader.readAsDataURL(this.eventFile);
    },
    isInvalid() {
      this.$v.$touch();

      return this.$v.$invalid;
    },
    handleChangeStudyCurrently(value) {
      if (!value) {
        this.dataToSend.studyLevel = 0;
      }
    },
    getCountry() {
      if (this.$refs['google-search-address']) {
        this.$refs['google-search-address'].clearSelected();
      }
    },
    handleAutoComplete(addressData) {
      this.dataToSend.street = addressData.route || addressData.place.name;
      this.dataToSend.city = addressData.locality;
      this.dataToSend.number = addressData.street_number || '';
      // const findCountry = this.countries.find((option) => option.text === addressData.country);
      // this.dataToSend.country = findCountry.value;
      // this.dataToSend.country = addressData.country;
      this.dataToSend.zip = addressData.postal_code;
    },
    handleInputBirthDate(payload) {
      this.dataToSend.birthDate = payload;
    },
    async handleInputPhoneCodeValidation() {
      let verif = await this.verifyMatchingCode();
      if (!verif) {
        this.stateError.phoneCodeValidation = false;
        this.codeVerified = false;
      } else {
        this.stateError.phoneCodeValidation = true;
        this.codeVerified = true;
      }
    },
    async verifyMatchingCode() {
      if (this.dataToCheck.licenseId) {
        try {
          const isValidFromServer = await checkLicensePhoneValidationCode(this.dataToCheck.licenseId, this.phoneCodeValidation);
          this.validateCodePhone = isValidFromServer.CheckLicensePhoneValidationCode;
          if (this.validateCodePhone) {
            this.dataToSend.phone = this.phoneE164;
          }
          return isValidFromServer.CheckLicensePhoneValidationCode;
        } catch (error) {
          return false;
        }
      }
    },
    async verifyPhone() {
      try {
        if (!this.isNANPCountry) {
          this.loadingFor.verifyPhone = true;
          const phone = this.phoneE164;
          const result = await phoneValidationCode({
            email: this.email,
            phone: this.phoneE164,
            language: 0
          });
          this.dataToCheck.licenseId = result.id;
          this.dataToCheck.phoneCodeValidation = 1;
          this.dataToCheck.phone = phone;

          this.showModalInfoCode = true;
          this.messageModalInfoCode = this.FormMSG(61, 'An SMS containing a validation code has just been sent to') + ' ' + phone;

          this.phoneCodeValidation = '';
          this.stateError.phoneCodeValidation = null;
          this.loadingFor.verifyPhone = false;
        } else {
          this.stateError.phoneCodeValidation = true;
          this.phoneValidated = true;
        }
      } catch (e) {
        this.stateError.msg = this.resolveGqlError(e);
        this.stateError.show = true;
        this.loadingFor.verifyPhone = false;
      }
    },
    handleDismissed() {
      this.stateError.show = false;
      this.stateError.msg = '';
    },
    handleUpdatePhoneNumber(payload) {
      // console.log({ payload });
      this.$v.$touch();

      if (payload.e164) {
        this.phoneE164 = payload.e164;
      } else {
        this.phoneE164 = '';
      }

      if (_.has(payload, 'isValid')) {
        this.disableVerifyPhone = !payload.isValid;
      }

      if (NANP_COUNTRY_CODES.includes(payload.countryCode)) {
        this.isNANPCountry = true;
      }

      this.variantPhoneBtn();
    },
    getStateValidationField(field) {
      const customCond = `this.$v.${field}.$error === false`;
      if (eval(customCond)) {
        return null;
      }

      return false;
    },
    handleNumberOnly() {
      const ext = /[\.]/g;
      if (ext.test(this.dataToSend.taxesPercentage)) {
        this.dataToSend.taxesPercentage = this.dataToSend.taxesPercentage.substring(0, this.dataToSend.taxesPercentage.indexOf('.'));
      }
    },
    handleInputChanged(elName) {
      this.$v.$touch();
      // console.log({ elName });
    },
    handleInputMaskChanged(payload) {
      this.inputMaskInTouch = true;
      this.$v.$touch();
      // console.log({ 'dataToSend.nationalRegistryNumber': this.dataToSend.nationalRegistryNumber });
    },
    closeValidationCode() {
      this.showModalInfoCode = false;

      setTimeout(() => {
        if (this.$refs['code-validation']) {
          this.$refs['code-validation'].focus();
        }
      }, 250);
    }
  },
  validations() {
    let result = {
      phone: { required },
      phoneCodeValidation: { required },
      dataToSend: {
        firstName: { required },
        name: { required },
        nationality: { required },
        birthDate: { required },
        placeOfBirth: { required },
        birthCountry: { required },
        gender: { required },
        nationalRegistryNumber: { required, nationalRegistryNumberValid },
        taxesPercentage: { required, greaterThanZero },
        iban: { required },
        countryKey: { required, greaterThanZero },
        street: { required },
        number: { required },
        zip: { required },
        city: { required },
        civilStatus: { required, greaterThanZero }
      }
    };

    return result;
  }
};
</script>
<style lang="scss">
#phone-number {
  input {
    border-radius: 0;
  }
}

#phone-number {
  &.is-invalid {
    input {
      border-color: #ea4e2c;
    }
  }
}
</style>
